import { useEffect, useRef, useState } from 'react';
import { useNotificationsCounter } from './NotificationsCounterProvider';

export default function useNewNotificationCounterStateN() {
  const unreadNotificationsCounter =
    useNotificationsCounter()?.unread_notifications_count;
  const previousNotificatonsCount = useRef<number>();

  const [newNotificationsCount, setNewNotificationsCount] = useState<number>();

  useEffect(() => {
    if (unreadNotificationsCounter === undefined) return;

    if (
      previousNotificatonsCount.current === undefined ||
      unreadNotificationsCounter === 0 ||
      unreadNotificationsCounter < previousNotificatonsCount.current
    ) {
      previousNotificatonsCount.current = unreadNotificationsCounter;
      setNewNotificationsCount(unreadNotificationsCounter);
    }

    if (unreadNotificationsCounter > previousNotificatonsCount.current) {
      setNewNotificationsCount(
        unreadNotificationsCounter - previousNotificatonsCount.current,
      );
    }

    previousNotificatonsCount.current = unreadNotificationsCounter;
  }, [unreadNotificationsCounter]);

  return newNotificationsCount;
}
